export enum SituacaoTour {
  Pendente = 1,
  Concluido = 2,
  Dispensado = 3
}
